import { ChartEvent, IBarrier } from '../../types'

export interface IBarrierSelectedToModal {
    selectedBarrier: IBarrier
    event: ChartEvent
    color: string
    statusName: string
}

export interface IBarrierSelectedToModalActionSetSelected {
    type: 'SET_SELECTED_BARRIER'
    payload: {
        newSelectedBarrier: IBarrier
        newEvent: ChartEvent
        newColor: string
        newStatusName: string
    }
}

export interface IBarrierSelectedToModalActionClose {
    type: 'CLOSE_MODAL'
}

export type IBarrierSelectedToModalAction =
    | IBarrierSelectedToModalActionSetSelected
    | IBarrierSelectedToModalActionClose

const initialState: IBarrierSelectedToModal = {
    selectedBarrier: null,
    event: null,
    color: null,
    statusName: null
}

export function barrierSelectedToModalReducer(
    state = initialState,
    action: IBarrierSelectedToModalAction
): IBarrierSelectedToModal {
    switch (action.type) {
        case 'SET_SELECTED_BARRIER':
            return {
                selectedBarrier: action.payload.newSelectedBarrier,
                event: action.payload.newEvent,
                color: action.payload.newColor,
                statusName: action.payload.newStatusName
            }

        case 'CLOSE_MODAL':
            return {
                selectedBarrier: null,
                event: null,
                color: null,
                statusName: null
            }

        default:
            return state
    }
}
